<template>
<div>
<flash-message class="myCustomClass"></flash-message>
<v-dialog v-model="dialog_view_modules" class="w-full md:w-1/2">

                <v-card>
                    <v-card-title>
                        <span class="headline">Canvas Orientation Modules for: {{ current_user.fullname }}</span>
                        <v-spacer></v-spacer>
                        <v-divider vertical class="mx-4"></v-divider>
                        <v-icon @click="close_view_modules">mdi-close</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>
                     <v-card-text>

  <v-simple-table light fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
           Module Name
          </th>
          <th class="text-left">
           Status
          </th>
          <th class="text-left">
           Status Date
          </th>
                    <th class="text-left">
           
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in Modules">
	  <td>{{ item.name }}</td>
	  <td>{{ item.state }}</td>
	  <td>{{ item.completed_at }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>	

                    </v-card-text>
                </v-card>

</v-dialog>
<v-card-title>
<h2>{{ ctitle }}</h2>
<v-spacer></v-spacer>
<v-select label="Select Columns to Display" :items="headers" v-model="filteredheaders" multiple return-object>
        <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item.text }}</span>
        </v-chip>
        <span
          v-if="index === 1"
          class="grey--text caption"
        >(+{{ filteredheaders.length - 1 }} others)</span>
      </template>
        </v-select>
      </v-flex>

<v-btn icon class="mx-0" @click="download">
  <v-icon title="Excel Download" color="green">save_alt</v-icon>
</v-btn>

<v-btn icon class="mx-0" @click="reset">
   <v-icon title="Reload" color="blue">refresh</v-icon>
</v-btn>

<v-btn icon class="mx-0" @click="print">
   <v-icon title="Print All Student Schedules for Orientation Date on the Search Ex: 6/11/2022.  *Note this will only display Advisor Accept courses." color="orange">print</v-icon>
</v-btn>

<v-text-field  clearable v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>

</v-card-title>   

<v-data-table v-if="isAdmin == 'true'" :footer-props="{'items-per-page-options': [100,200,1000]}"  :headers="filteredheaders"
:loading=progress_bar_loading :items="filteredResults" :search="search" class="elevation-1" :options.sync="pagination" show-group-by group-by="orientation_start_dt" sort-by="has_registered"  multi-sort>

<v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>

<template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
          <span> {{ header.text }} </span>
	  <div v-if="headers_to_filter.includes(header.text)">
          <div v-if="filters.hasOwnProperty(header.value)">
								<v-combobox
									flat
									hide-details
									multiple
									attach
									chips
									full-width
									hide-no-data
									clearable
                 						        disable-lookup
									:items="columnValueList(header.value).sort()"
									v-model="filters[header.value]">
                  							<template v-slot:selection="{ item, index }">
                      							<v-chip v-if="index < 5">
											 <span> 
                        									{{ item }} 
                      									 </span>
									</v-chip>
									<span v-if="index === 5" class="grey--text caption" > 
                      							(+{{ filters[header.value].length - 5 }} others) 
                      							</span>
									</template>
								</v-combobox>
							</div>
							</div>
	</template>

<template slot="items" slot-scope="props">
  <td class="table-fit" v-for="header in filteredheaders">
    <span
      style="font-size: 100%"
      v-bind:class="BackgroundColor(props.item, header.value)"
      >{{ props.item[header.value] }}</span
    >
  </td>
</template>

<v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no results.</v-alert>

<template v-slot:item.orientation_one_module_result="{ item }">
<v-icon title="View Orientation module info" @click="moduleinfo(item)">visibility</v-icon>
</template>

<template v-slot:item.email="{ item }">
  <a :href="'mailto:' + item.netid + '@uis.edu'">{{
    `${item.netid}@uis.edu`
  }}</a>
</template>

<template v-slot:item.id="{ item }">
  <a
    :href="
      '/tentativecourses/indexbyuin/' +
      item.uin +
      '/' +
      semester 
    "
    ><v-icon title="View student info">visibility</v-icon></a
  >
  <v-icon v-if="item.has_worksheet === true" title="Has worksheet" color="green"
    >done</v-icon
  >
</template>

<template v-slot:item.registered="{ item }">
  <span v-if="item.has_registered == 'Yes'"
    ><v-chip color="green" dark>Yes</v-chip></span
  ><span v-else><v-chip color="orange" dark>No</v-chip></span>
</template>

<template v-slot:item.has_registered_previous="{ item }">
  <span v-if="item.has_registered_previous == 'Yes'"
    ><v-chip color="green" dark>Yes</v-chip></span
  ><span v-else><v-chip color="orange" dark>No</v-chip></span>
</template>

</v-data-table>

</v-card>

</div>
</template>

<script>
import XLSX from "xlsx";

export default {
  data() {
    return {
      app_name: process.env.MIX_APP_NAME,
      search: this.search_by,
      fill: [],
      headers_to_filter: ['Orientation Type', 'Major', 'Primary Advisor', 'Registered Previous', 'Orientation Date', 'Attended Orientation'],
      filteredheaders: [],
      filteredheaderarray: [],
      headerarray: [],
      progress_bar_loading: true,
      dialog: false,
      dialog_view_modules: false,
      current_user: {},
      rowsPerPageItems: [10, 50, 100, 2000],
      missing_header: {
        text: "Registered for Fall",
        value: "has_registered",
        sortable: true,
      },
      headers: [
        { text: "Actions", value: "id", sortable: false, groupable: false },
        { text: "Student UIN", value: "uin", sortable: true, groupable: false },
        { text: "Student Name", value: "fullname", sortable: true },
        {
          text: "Student Email",
          value: "email",
          sortable: true,
          groupable: false,
        },
        { text: "Major", value: "major", sortable: true,  width: 350 },
        {
          text: "Primary Advisor",
          value: "primary_advisor_name",
          sortable: true,
	  width: 350,
        },
        { text: "Admit Type", value: "admit_type", sortable: true },
        { text: "Application Term", value: "application_term_code", sortable: true },
        {
          text: "Has Registered",
          value: "registered",
          sortable: true,
        },
        {
          text: "Registered Courses",
          value: "registered_courses",
          sortable: false,
          groupable: false,
        },
        {
          text: "Registered Previous",
          value: "has_registered_previous",
          sortable: false,
        },
        {
          text: "Advisor Appt Info",
          value: "appointment_info",
          sortable: false,
          groupable: false,
        },
        {
          text: "Canvas Module Status",
          value: "orientation_one_module_result",
          sortable: true,
        },
        {
          text: "Holds",
          value: "holds",
          sortable: false,
        },
        {
          text: "Attended Orientation",
          value: "attended_orientation",
          sortable: true,
	  width: 300,
        },
        {
          text: "Orientation Date",
          value: "orientation_start_dt",
          sortable: true,
	  width: 350,
        },
        { text: "Orientation Type", value: "orientation_type", sortable: true, width: 350 },
      ],

      filters: {
        uin: [],
        fullname: [],
        major: [],
	primary_advisor_name: [],
        has_registered: [],
        has_registered_previous: [],
        admit_type: [],
        appointment_info: [],
        orientation_one_module_result: [],
        holds: [],
        attended_orientation: [],
        orientation_start_dt: [],
        orientation_type: [],
      },

      selected: [],
      pagination: {},

      Results: [],
      Modules: [],
    };
  },
  created() {
    this.initialize();
  },
  props: {
    ctitle: {
      type: String,
      required: true,
    },
    search_by: {
      type: String,
      required: true,
    },
    isAdmin: {
      type: String,
      required: true,
    },
    semester: {
      type: String,
      required: true,
    },
    orientation_course: {
      type: String,
      required: true,
    },
  },
  computed: {
    filteredResults() {
      return this.Results.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },

  methods: {
    columnValueList(val) {
      return this.Results.map((d) => d[val]);
    },

    mounted() {},
    initialize() {
      this.fetchApp();
      this.filteredheaders = this.headers;
    },
    close() {
      this.dialog = false;
    },
    async fetchApp() {
      await axios
        .get("/api/v1/placement")
        .then((response) => {
          this.Results = response.data;
          this.progress_bar_loading = false;
        })
        .catch((error) => {});
    },
    async moduleinfo(item) {
        this.Modules = [];
	this.current_user = item;
	this.dialog_view_modules = true;
	await axios
        .get("/api/v1/moduleinfo/" + item.netid + "/" + this.orientation_course)
        .then((response) => {
          this.Modules = response.data.modules;
        })
        .catch((error) => {});
    },
    close_view_modules()
	{
	   this.dialog_view_modules = false;
	},
    print(){
       axios({
          url: '/tentativecourses/' + this.semester + '/byorientationdatepdf',
          method: 'POST',
          data: { orientation_date: this.search },
          responseType: 'blob', // important
        }).then((response) => {
          if (!window.navigator.msSaveOrOpenBlob){
            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/pdf'}));
            const link = document.createElement('a');
            link.href = url;
	    link.setAttribute('download', this.app_name + '_' + this.search  + '.pdf');

            document.body.appendChild(link);
            link.click();
          }else{
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), this.app_name + '_app_export_' + date.getTime() + '.pdf');
          }
        }).catch(error=>{

        })
    },
    customFilter(items, search, filter) {
      search = search.toString().toLowerCase();
      this.fill = items.filter((i) =>
        Object.keys(i).some((j) => filter(i[j], search))
      );

      return this.fill;
    },
    reset() {
      this.fetchApp();
    },
    download() {
      var first_record_json;
      var all_headers;
      var first_record_json;
      var first_record_json_keys;
      var all_headers_not;

      var local_delete = [];

      this.filteredheaders.forEach((element) =>
        this.filteredheaderarray.push(element.value)
      );

      //ADDED has_registered because it was a computed value (template v-slot) that would not go in the download
      this.filteredheaderarray.push(this.missing_header.value);

      this.headers.forEach((element) => this.headerarray.push(element.value));
      first_record_json = this.Results[0];

      first_record_json_keys = Object.keys(first_record_json);
      all_headers_not = first_record_json_keys.filter(
        (x) => !this.filteredheaderarray.includes(x)
      );

      // local_delete = this.fill;
      local_delete = this.filteredResults; // change this when I figure out how the customFilter should work

      for (var k = 0; k < local_delete.length; k++) {
        for (var i = 0; i < all_headers_not.length; i++) {
          var key = all_headers_not[i];
          delete local_delete[k][key];
        }
      }

      var work = XLSX.utils.json_to_sheet(local_delete);
      var new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, work, "SheetJS");
      var date = new Date();
      XLSX.writeFile(
        new_workbook,
        this.app_name + "_app_export_" + date.getTime() + ".xlsx"
      );
      this.filteredheaderarray = [];
      this.headerarray = [];
    },

    BackgroundColor: function (equipment, key) {
      var result = "";

      if (key == "status") {
        if (equipment.status.includes("Overdue")) {
          result = "badge p-2 h-3 font-weight-light badge-warning";
        } else if (equipment.status.includes("Due")) {
          result = "badge p-2 h-3 font-weight-light badge-info";
        } else {
          result = "badge p-2 font-weight-light badge-success";
        }
      }

      return result;
    },
  },
};
</script>
